import React from 'react';
import moment from 'moment';
import { groupBy, prop, map, pathOr, merge } from 'ramda';

import { CampaignPeriod } from './SafegraphVisitorShare/SafegraphVisitorShare';

const MAX_TICK_TOTAL = 15;

const tickFormatXAxis = (value: string) => (
  <tspan>
    <tspan x="0" dy="1em">
      {moment(value).format('DD')}
    </tspan>

    <br />

    <tspan x="0" dy="1em">
      {moment(value).format('MMM')}
    </tspan>
  </tspan>
);

const groupByCampaign = groupBy(prop('campaignPeriod') as any);

const averageLinesMapping = (
  data: { [key: string]: unknown[] },
  queryFieldName: string,
  fieldName: string,
) =>
  map((metric: { campaignPeriod: CampaignPeriod }) =>
    merge(metric, {
      [fieldName]: pathOr(0, [metric.campaignPeriod, 0, queryFieldName], data),
    }),
  ) as any;

export {
  MAX_TICK_TOTAL,
  tickFormatXAxis,
  groupByCampaign,
  averageLinesMapping,
};
